import { BaseComponent } from '../core/BaseComponent';

export interface AccordionOptions {
  exclusive: boolean;
  items: string;
  trigger: string;
  content: string;
  onToggle?: (item: HTMLElement, isOpen: boolean) => void;
}

export class Accordion extends BaseComponent<AccordionOptions> {
  private items: HTMLElement[] = [];

  protected getDefaultOptions(): AccordionOptions {
    return {
      exclusive: true,
      items: '.card, .accordion-item',
      trigger: '.card-header, .accordion-header',
      content: '.card-body, .accordion-body'
    };
  }

  protected init(): void {
    super.init();
    this.items = Array.from(this.element.querySelectorAll(this.options.items));
    
    this.items.forEach((item, index) => {
      const trigger = item.querySelector(this.options.trigger) as HTMLElement;
      const content = item.querySelector(this.options.content) as HTMLElement;
      const contentId = `acc-content-${this.generateId()}-${index}`;
      
      if (trigger && content) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-controls', contentId);
        content.id = contentId;
        content.setAttribute('role', 'region');
        
        trigger.addEventListener('click', () => this.toggle(item));
      }
    });
  }

  public toggle(item: HTMLElement): void {
    const trigger = item.querySelector(this.options.trigger);
    const content = item.querySelector(this.options.content);
    if (!content) return;

    const isOpen = !content.classList.contains('d-none');

    if (this.options.exclusive && !isOpen) {
      this.items.forEach(i => {
        const c = i.querySelector(this.options.content);
        const t = i.querySelector(this.options.trigger);
        if (c) c.classList.add('d-none');
        i.classList.remove('is-open');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    content.classList.toggle('d-none');
    item.classList.toggle('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', String(!isOpen));

    if (this.options.onToggle) this.options.onToggle(item, !isOpen);
    this.emit('toggle', { item, isOpen: !isOpen });
  }

  private generateId(): string {
    return Math.random().toString(36).substr(2, 9);
  }
}
